"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

/**
 * Empty component for the future purposes.
 */
var Body = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'tbody' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    ref: ref
  }, restProps), children);
});

var _default = Body;
exports["default"] = _default;